module.exports = __webpack_public_path__ + "img/hat1_6a3_2.50031cc6.svg";